import { HeroSession } from "../components/Hero";
import { Step } from "components/Step";
import { FAQ } from "../components/FAQ";
import { ContactForm } from "components/ContactForm";
import RewardCompanies from "components/RewardCompanies/RewardCompanies";
import { Features } from "components/Hero/Features";

/**
 * Landing page. Sections alternate canvas / surface bands, each separated by a
 * hairline border: hero → reward partners → features → how it works → FAQ → contact.
 */
export const Home = () => {
  return (
    <>
      <HeroSession />
      <RewardCompanies />
      <Features />
      <Step />
      <FAQ />
      <ContactForm />
    </>
  );
};
